import React from 'react';
import { Paragraph, Skeleton, tokens } from '@welbe/web-design-system';
import {
	Container,
	AlertContainer,
	TableContainer,
	ImgContainer,
	TdName,
	TdType,
	TdFrequency,
} from './ExamsRecommendations.styles';
import { FiAlertCircle } from 'react-icons/fi';
import { SummaryJobRisksExams } from 'Views/JobProfile/pages/SummaryRisk/SummaryRisk.types';

import physics from '../../assets/physics.png';
import chemical from '../../assets/chemical.png';
import biological from '../../assets/biological.png';
import ergonomic from '../../assets/ergonomic.png';
import psychosocial from '../../assets/psychosocial.png';

type ExamsRecommendationsType = {
	isLoading: boolean;
	recommendedExams?: SummaryJobRisksExams[];
};

const assets: any = {
	fisicos: physics,
	quimicos: chemical,
	biologicos: biological,
	ergonomicos: ergonomic,
	psicosociales: psychosocial,
};

const removeSpecialCharacters = (text: string) => {
	return text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-zA-Z0-9]/g, '')
		.toLowerCase();
};

const getAsset = (name: string) => {
	if (!name) return null;
	const assetFormatted = removeSpecialCharacters(name);

	return assets[assetFormatted];
};

export const ExamsRecommendations = ({
	isLoading,
	recommendedExams,
}: ExamsRecommendationsType) => {
	return (
		<Container>
			<Paragraph
				fontWeight="600"
				padding="0 0 20px"
				color={tokens.color_primary}
			>
				Estudios médicos recomendados
			</Paragraph>
			<AlertContainer>
				<FiAlertCircle color={tokens.color_primary} />
				<Paragraph>
					Los estudios médicos son propuestos en función de la normatividad de
					la Secretaría del Trabajo, por lo que la selección de estos, queda
					sujeta a lo que determinen los responsables de seguridad y salud en el
					trabajo de la empresa.
				</Paragraph>
			</AlertContainer>
			<TableContainer>
				<tr>
					<th>Nombre de estudio</th>
					<th>Tipo de examen</th>
					<th>Frecuencia</th>
					<th>Agentes de riesgo relacionados</th>
				</tr>
				{isLoading ? (
					<tr>
						<td>
							<Skeleton width="100%" height="30px" />
						</td>
						<td>
							<Skeleton width="100%" height="30px" />
						</td>
						<td>
							<Skeleton width="100%" height="30px" />
						</td>
						<td>
							<Skeleton width="100%" height="30px" />
						</td>
					</tr>
				) : (
					<>
						{recommendedExams ? (
							<>
								{recommendedExams.map((exam: SummaryJobRisksExams) => (
									<tr key={exam.id}>
										<TdName>
											<Paragraph
												fontWeight="500"
												padding="0 0 0 10px"
												title={exam.name}
											>
												{exam.name}
											</Paragraph>
										</TdName>
										<TdType>
											{exam?.type?.map((item) => (
												<>
													{item && (
														<li key={item} title={item}>
															{item}
														</li>
													)}
												</>
											))}
										</TdType>
										<TdFrequency>
											{exam?.frequency?.map((item) => (
												<>
													{item && (
														<li key={item} title={item}>
															{item}
														</li>
													)}
												</>
											))}
										</TdFrequency>
										<td>
											<ImgContainer>
												{exam.images?.map((item, index) => (
													<img
														key={index}
														src={getAsset(item.name)}
														title={item.name}
														alt={item.name}
													/>
												))}
											</ImgContainer>
										</td>
									</tr>
								))}
							</>
						) : (
							<tr>
								<td />
								<td />
								<td />
								<td />
							</tr>
						)}
					</>
				)}
			</TableContainer>
		</Container>
	);
};
